import { get } from 'lodash';

import { AnyFormValues } from '@funnels/types';
import { FIELD_PATHS, EXPENSE_TYPE } from '@funnels/constants';

export default function getExpenseTypeIndex(
  expensesIndex: number = 0,
  formValues: AnyFormValues,
  expenseType: EXPENSE_TYPE
) {
  const expenses = get(formValues, FIELD_PATHS.EXPENSES(), []);
  const expenseTypeIndex = get(formValues, FIELD_PATHS.EXPENSES_EXPENSES(expensesIndex), []).findIndex(
    (__: any, index: number) =>
      get({ expenses }, FIELD_PATHS.EXPENSES_EXPENSE_TYPE(expensesIndex, index)) === expenseType
  );
  return expenseTypeIndex;
}
